import { CustomCSSProperties } from '../../types'
import { breakpointsArray } from 'src/styles/js/breakpoints'
import { BreakpointProperties } from './types'

const applyBreakpointStyles = (
  property: BreakpointProperties,
  stylePrefix: string,
): CustomCSSProperties => {
  const customStyles: CustomCSSProperties = {}
  let highestBreakpoint = null
  let highestIndex = -1
  let lowestBreakpoint = null
  let lowestIndex = breakpointsArray.length // Start with the maximum possible index

  if (typeof property === 'number') {
    // Set all breakpoints to this number if property is directly a number
    breakpointsArray.forEach((bp) => {
      customStyles[`--${stylePrefix}-${bp}`] = property
    })
  } else if (typeof property === 'object' && property !== null) {
    // Set styles for specified breakpoints if property is an object
    Object.keys(property).forEach((key) => {
      if (breakpointsArray.includes(key)) {
        customStyles[`--${stylePrefix}-${key}`] = property[key]
        // Determine the highest specified breakpoint
        const currentIndex = breakpointsArray.indexOf(key)
        if (currentIndex > highestIndex) {
          highestIndex = currentIndex
          highestBreakpoint = key
        }
        if (currentIndex < lowestIndex) {
          lowestIndex = currentIndex
          lowestBreakpoint = key
        }
      }
    })

    // Extend the last specified value upwards
    if (highestBreakpoint) {
      const highestValue = property[highestBreakpoint]
      const remainingBreakpoints = breakpointsArray.slice(highestIndex + 1)
      remainingBreakpoints.forEach((bp) => {
        customStyles[`--${stylePrefix}-${bp}`] = highestValue
      })
    }
    // Extend the smallest specified value downwards
    if (lowestBreakpoint) {
      const lowestValue = property[lowestBreakpoint]
      const precedingBreakpoints = breakpointsArray.slice(0, lowestIndex)
      precedingBreakpoints.forEach((bp) => {
        customStyles[`--${stylePrefix}-${bp}`] = lowestValue
      })
    }
  } else if (typeof property === 'string') {
    // Apply the same string value to all breakpoints
    breakpointsArray.forEach((bp) => {
      if (property === 'between' || property === 'around' || property === 'evenly') {
        customStyles[`--${stylePrefix}-${bp}`] = `space-${property}`
      } else {
        customStyles[`--${stylePrefix}-${bp}`] = property
      }
    })
  }
  return customStyles
}

export default applyBreakpointStyles
